import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import "../Register.css";
import { useDispatch } from "react-redux";
import { Row, Col, Card, message, Radio } from "antd";
import "./SignupPages.css";
import { Form, Input, Button, Checkbox, DatePicker, Spin, Steps, Select } from "antd";
import ReactInputMask from "react-input-mask";
import dayjs from "dayjs";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import fertilityImage from "../../../assets/images/auth/fertilityImage.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { postCompleteSignUp, getSignupPrefillByEmail } from "../../redux/AuthController";

const countries = [
  { label: "USA", value: "USA" },
  { label: "Canada", value: "Canada" },
];
const pronouns = [
  { label: "She/Her", value: "She/Her", gender: "female" },
  { label: "He/Him", value: "He/Him", gender: "male" },
  { label: "They/Them", value: "They/Them", gender: "other" },
];
const sexOptions = [
  { label: "Female", value: "Female" },
  { label: "Male", value: "Male" },
  { label: "Intersex", value: "Intersex" },
  { label: "Prefer not to say", value: "Prefer not to say" },
];

const CompleteSignup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showSpinner, setShowSpinner] = useState(false);
  const [feet, setFeet] = useState("");
  const [inches, setInches] = useState("");
  const [form] = Form.useForm();
  const { Item: FormItem } = Form;
  // Debounces the localStorage draft-save below so typing doesn't
  // synchronously JSON.stringify + write the whole form on every keystroke.
  const saveDraftTimeoutRef = useRef(null);
  const [password, setPassword] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const [username, setUsername] = useState("");
  const [passwordValidations, setPasswordValidations] = useState({
    minLength: false,
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
    notUsername: false,
  });

  const initialValues = {
    role: "4",
    userName: "",
    firstName: "",
    lastName: "",
    PreferredName: "",
    Pronouns: "",
    gender: "",
    password: "",
    cpassword: "",
    email: "",
    phoneNumber: "",
    address: "",
    appartmentOrSuite: "",
    country: "",
    stateProvince: "",
    city: "",
    postalCode: "",
    dob: null,
    height: 0,
    weight: 0,
    uli: "",
    MetricImperial: false,
    isSMS: false,
    isSendResultToEmail: false,
    IAgreeToReceiveInformation: false,
    isAcceptTermsAndCondition: false,
    AgreeToUseData: false,
    DigitalSignature: false,
    DigitalSignatureName: null,
    // Partner details
    PartnerFirstName: "",
    PartnerLastName: "",
    PartnerSex: "",
    PartnerPronouns: "",
    PartnerDob: null,
  };

  const requiredFields = useMemo(() => [
    "isSMS",
    "isSendResultToEmail",
    "IAgreeToReceiveInformation",
    "isAcceptTermsAndCondition",
    "DigitalSignature",
    "DigitalSignatureName",
  ], []);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [step0Valid, setStep0Valid] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedPronoun, setSelectedPronoun] = useState(null);
  const [selectedPartnerPronoun, setSelectedPartnerPronoun] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [unit, setUnit] = useState("Metric");
  const [heightOfPatient, setHeightOfPatient] = useState("");
  const [weightOfPatient, setWeightOfPatient] = useState("");
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem("completeSignup_step");
    return savedStep ? parseInt(savedStep, 10) : 0;
  });
  const [dob, setDob] = useState("");
  const [partnerDob, setPartnerDob] = useState("");
  console.log("partnerDob:", partnerDob);
  const startYear = 2007;

  const states = useMemo(() => ({
    USA: [
      { label: "Alabama", value: "AL" },
      { label: "Alaska", value: "AK" },
      { label: "Arizona", value: "AZ" },
      { label: "Arkansas", value: "AR" },
      { label: "California", value: "CA" },
      { label: "Colorado", value: "CO" },
      { label: "Connecticut", value: "CT" },
      { label: "Delaware", value: "DE" },
      { label: "Florida", value: "FL" },
      { label: "Georgia", value: "GA" },
      { label: "Hawaii", value: "HI" },
      { label: "Idaho", value: "ID" },
      { label: "Illinois", value: "IL" },
      { label: "Indiana", value: "IN" },
      { label: "Iowa", value: "IA" },
      { label: "Kansas", value: "KS" },
      { label: "Kentucky", value: "KY" },
      { label: "Louisiana", value: "LA" },
      { label: "Maine", value: "ME" },
      { label: "Maryland", value: "MD" },
      { label: "Massachusetts", value: "MA" },
      { label: "Michigan", value: "MI" },
      { label: "Minnesota", value: "MN" },
      { label: "Mississippi", value: "MS" },
      { label: "Missouri", value: "MO" },
      { label: "Montana", value: "MT" },
      { label: "Nebraska", value: "NE" },
      { label: "Nevada", value: "NV" },
      { label: "New Hampshire", value: "NH" },
      { label: "New Jersey", value: "NJ" },
      { label: "New Mexico", value: "NM" },
      { label: "New York", value: "NY" },
      { label: "North Carolina", value: "NC" },
      { label: "North Dakota", value: "ND" },
      { label: "Ohio", value: "OH" },
      { label: "Oklahoma", value: "OK" },
      { label: "Oregon", value: "OR" },
      { label: "Pennsylvania", value: "PA" },
      { label: "Rhode Island", value: "RI" },
      { label: "South Carolina", value: "SC" },
      { label: "South Dakota", value: "SD" },
      { label: "Tennessee", value: "TN" },
      { label: "Texas", value: "TX" },
      { label: "Utah", value: "UT" },
      { label: "Vermont", value: "VT" },
      { label: "Virginia", value: "VA" },
      { label: "Washington", value: "WA" },
      { label: "West Virginia", value: "WV" },
      { label: "Wisconsin", value: "WI" },
      { label: "Wyoming", value: "WY" },
    ],
    Canada: [
      { label: "Alberta", value: "AB" },
      { label: "British Columbia", value: "BC" },
      { label: "Manitoba", value: "MB" },
      { label: "New Brunswick", value: "NB" },
      { label: "Newfoundland and Labrador", value: "NL" },
      { label: "Northwest Territories", value: "NT" },
      { label: "Nova Scotia", value: "NS" },
      { label: "Nunavut", value: "NU" },
      { label: "Ontario", value: "ON" },
      { label: "Prince Edward Island", value: "PE" },
      { label: "Quebec", value: "QC" },
      { label: "Saskatchewan", value: "SK" },
      { label: "Yukon", value: "YT" },
    ],
  }), []);

  const disableBefore2006 = (current) => {
    return current && current.isAfter(dayjs(`${startYear}-01-01`));
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z\s'-]/g, "");
    form.setFieldsValue({
      [e.target.name]: sanitizedValue,
    });
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  // Looks up a quick-signup user by email to prefill fields we already have on file.
  // The backend endpoint doesn't exist yet, so this will currently always fail
  // caught silently below so the form stays fully fillable either way.
  const handleEmailLookup = async () => {
    const typedEmail = form.getFieldValue("email");
    if (!typedEmail) return;

    try {
      const result = await dispatch(getSignupPrefillByEmail(typedEmail));
      if (getSignupPrefillByEmail.fulfilled.match(result) && result.payload?.Found) {
        const data = result.payload;
        form.setFieldsValue({
          firstName: data.FirstName || "",
          lastName: data.LastName || "",
          phoneNumber: data.PhoneNumber || "",
          gender: data.Gender || "",
        });
      }
      // No match, or the lookup failed (endpoint not implemented yet) 
    } catch {
      // Silently ignores, user can still fill the form in manually
    }
  };

  useEffect(() => {
    const validatePassword = (pwd) => {
      return {
        minLength: pwd.length >= 8,
        lowercase: /[a-z]/.test(pwd),
        uppercase: /[A-Z]/.test(pwd),
        number: /[0-9]/.test(pwd),
        specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
        notUsername: pwd !== username,
      };
    };
    setPasswordValidations(validatePassword(password));
  }, [password, username]);

  const handleDateChange = (date, dateString) => {
    setDob(dateString);
  };

  const handlePartnerDateChange = (date, dateString) => {
    setPartnerDob(dateString);
  };

  const disableUnder18Years = (current) => {
    return current && current.isAfter(dayjs().subtract(18, "years").endOf("day"));
  };

  const checkRequiredFields = useCallback((values) => {
    return requiredFields.every((field) => {
      const value = values[field];
      if (field === "DigitalSignatureName") {
        return value && typeof value === "string" && value.trim().length > 0;
      }
      return value === true;
    });
  }, [requiredFields]);

  const checkStep0Fields = useCallback((values) => {
    const step0RequiredFields = [
      "firstName",
      "lastName",
      "userName",
      "gender",
      "Pronouns",
      "password",
      "confirmPassword",
      "email",
      "uli",
      "address",
      "country",
      "stateProvince",
      "city",
      "postalCode",
      "phoneNumber",
      "dob",
      "Height",
      "Weight",
    ];

    const allFieldsFilled = step0RequiredFields.every((field) => {
      const value = values[field];
      if (!value) return false;
      if (typeof value === "string" && value.trim().length === 0) return false;
      return true;
    });

    const passwordsMatch = values.password === values.confirmPassword && values.password;

    return allFieldsFilled && passwordsMatch;
  }, []);

  const customizeRequiredMark = (label, { required }) => (
    <>
      {label}
      {required && <span style={{ color: "red" }}>*</span>}
    </>
  );

  const handleSetUnit = (checked) => {
    setUnit(checked);
    setHeightOfPatient("");
    setWeightOfPatient("");
    form.resetFields(["Height", "Weight"]);
    form.validateFields(["Height", "Weight"]);
  };

  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        setFormValues({ ...formValues, ...values });
        setCurrentStep(currentStep + 1);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const prevStep = () => setCurrentStep(currentStep - 1);

  const handleFinish = async (values) => {
    const allFormValues = { ...formValues, ...values };

    try {
      setShowSpinner(true);

      const extractGenderValue = (genderField) => {
        if (typeof genderField === "string") return genderField;
        if (typeof genderField === "object" && genderField?.value) return genderField.value;
        if (typeof genderField === "object" && genderField?.label) return genderField.label;
        return "Female";
      };

      const payload = {
        FirstName: allFormValues.firstName || "",
        LastName: allFormValues.lastName || "",
        PreferredName: allFormValues.PreferredName || "",
        Pronouns: selectedPronoun?.value || allFormValues.Pronouns || "",
        Email: allFormValues.email || "",
        Password: allFormValues.password || "",
        PhoneNumber: allFormValues.phoneNumber || "",
        DOB: dob || allFormValues.dob || "",
        Gender: extractGenderValue(allFormValues?.gender),
        Address: allFormValues.address || "",
        AppartmentOrSuite: allFormValues.appartmentOrSuite || "",
        Country: selectedCountry?.label || allFormValues.country || "",
        StateOrProvince: selectedState?.label || allFormValues.stateProvince || "",
        City: allFormValues.city || "",
        PostalCode: allFormValues.postalCode || "",
        MetricImperial: unit === "Metric",
        Height: parseFloat(allFormValues.Height) || 0,
        Weight: parseFloat(allFormValues.Weight) || 0,
        Uli: allFormValues.uli || "",
        IsSMS: !!allFormValues.isSMS,
        IsSendResultToEmail: !!allFormValues.isSendResultToEmail,
        IsAcceptTermsAndConditions: !!allFormValues.isAcceptTermsAndCondition,
        AgreeToUseData: false,
        DigitalSignature: !!allFormValues.DigitalSignature,
        Signature: allFormValues.DigitalSignatureName || "",
        IsAssessor: false,
        LicenseDocument: "",
        Designation: "",
        LicenceNumber: "",
      };

      const response = await dispatch(postCompleteSignUp(payload));

      if (postCompleteSignUp.rejected.match(response)) {
        const err = response.payload;
        const errorMessage =
          (typeof err === "object" && (err?.message || err?.Message)) ||
          String(err || "Something went wrong. Please try again.");
        message.error(errorMessage);
        return;
      }

      localStorage.removeItem("completeSignup_step");
      localStorage.removeItem("completeSignup_formValues");
      toast.success("Registration complete! Please sign in to continue.");
      navigate("/");
    } catch (err) {
      console.error("Error submitting form:", err);
      message.error("There was an error submitting the form. Please try again.");
    } finally {
      setShowSpinner(false);
    }
  };

  // Revalidate step 0 when form values change
  useEffect(() => {
    if (currentStep === 0) {
      const allValues = form.getFieldsValue();
      setStep0Valid(checkStep0Fields(allValues));
    }
  }, [formValues, currentStep, form, checkStep0Fields]);

  // Save current step to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("completeSignup_step", currentStep.toString());
  }, [currentStep]);

  // Save form values to localStorage whenever they change
  useEffect(() => {
    if (Object.keys(formValues).length > 0) {
      localStorage.setItem("completeSignup_formValues", JSON.stringify(formValues));
    }
  }, [formValues]);

  // Load saved form values (or fall back to the quick-start draft) on mount
  useEffect(() => {
    const savedFormValues = localStorage.getItem("completeSignup_formValues");
    let parsedValues = null;
    if (savedFormValues) {
      try {
        parsedValues = JSON.parse(savedFormValues);
        if (parsedValues.dob) parsedValues.dob = dayjs(parsedValues.dob);
        if (parsedValues.PartnerDob) parsedValues.PartnerDob = dayjs(parsedValues.PartnerDob);
      } catch (error) {
        console.error("Error loading saved form values:", error);
        parsedValues = null;
      }
    }

    if (parsedValues) {
      setFormValues(parsedValues);
      form.setFieldsValue(parsedValues);

      if (parsedValues.country) {
        const matchingCountry = countries.find((c) => c.value === parsedValues.country || c.label === parsedValues.country);
        if (matchingCountry) setSelectedCountry(matchingCountry);
      }
      if (parsedValues.stateProvince && parsedValues.country) {
        const countryValue = typeof parsedValues.country === "string"
          ? countries.find((c) => c.label === parsedValues.country)?.value || parsedValues.country
          : parsedValues.country;
        const stateList = states[countryValue];
        if (stateList) {
          const matchingState = stateList.find((s) => s.value === parsedValues.stateProvince || s.label === parsedValues.stateProvince);
          if (matchingState) setSelectedState(matchingState);
        }
      }
      if (parsedValues.Pronouns) {
        const matchingPronoun = pronouns.find((p) => p.value === parsedValues.Pronouns);
        if (matchingPronoun) setSelectedPronoun(matchingPronoun);
      }
      if (parsedValues.dob) setDob(parsedValues.dob);

      setButtonDisabled(!checkRequiredFields(parsedValues));
      if (currentStep === 0) setStep0Valid(checkStep0Fields(parsedValues));
    } else {
      // No saved progress — apply the quick-start prefill
      form.setFieldsValue(initialValues);
      setStep0Valid(checkStep0Fields(initialValues));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="">
        <div className="full-width-container">
          <Row gutter={24} style={{ height: "100vh" }}>
            <Col
              span={2}
              className="column-1"
              style={{ backgroundColor: "#EFD0BD" }}
            ></Col>
            <Col span={20} className="column-2">
              <div className="form-scrollable">
                <div className="col-xl-9 col-lg-10 col-md-12">
                  <nav className="navbar mt-3">
                    <img
                      className="float-left"
                      src={fertilityImage}
                      alt="loginImage"
                      style={{ width: "150px" }}
                    />
                    <form className="d-flex" role="search">
                      <NavLink
                        to="/"
                        className="btn btn-primary btn-user btn-block"
                        style={{ background: "#00ADEF", border: "none" }}
                      >
                        <span>Sign In</span>
                      </NavLink>
                    </form>
                  </nav>
                  <div className="card o-hidden border-0  my-3">
                    <div className="card-body p-5">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="">
                            <div>
                              {currentStep === 0 && (
                                <p style={{ fontSize: 20, fontWeight: 700, color: "#000", textAlign: "center" }}>
                                  Personal Information
                                </p>
                              )}
                              {currentStep === 1 && (
                                <p style={{ fontSize: 20, fontWeight: 700, color: "#000", textAlign: "center" }}>
                                  Partner Information (Optional)
                                </p>
                              )}
                              {currentStep === 2 && (
                                <p style={{ fontSize: 20, fontWeight: 700, color: "#000", textAlign: "center" }}>
                                  Agreements
                                </p>
                              )}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                width: "200px",
                                margin: "0 auto",
                              }}
                            >
                              <div style={{ height: "2px", backgroundColor: currentStep === 0 ? "#01ACEE" : "gray", flex: 1 }}></div>
                              <div style={{ height: "2px", backgroundColor: currentStep === 1 ? "#01ACEE" : "gray", flex: 1 }}></div>
                              <div style={{ height: "2px", backgroundColor: currentStep === 2 ? "#01ACEE" : "gray", flex: 1 }}></div>
                            </div>

                            <Form
                              layout="vertical"
                              form={form}
                              onFinish={handleFinish}
                              requiredMark={customizeRequiredMark}
                              initialValues={initialValues}
                              autoComplete="off"
                              onValuesChange={(changedValues, allValues) => {
                                setButtonDisabled(!checkRequiredFields(allValues));
                                if (currentStep === 0) {
                                  setStep0Valid(checkStep0Fields(allValues));
                                }
                                const updatedFormValues = { ...formValues, ...allValues };
                                setFormValues(updatedFormValues);
                             
                                clearTimeout(saveDraftTimeoutRef.current);
                                saveDraftTimeoutRef.current = setTimeout(() => {
                                  localStorage.setItem("completeSignup_formValues", JSON.stringify(updatedFormValues));
                                }, 1000);
                              }}
                            >
                              <Steps
                                current={currentStep}
                                style={{ marginTop: 10, height: 30 }}
                                direction={"horizontal"}
                              >
                              </Steps>

                              <FormItem name="role" initialValue={"4"} rhidden>
                                <Input type="hidden" value={"4"} />
                              </FormItem>

                              {currentStep === 0 && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="First Name"
                                        name="firstName"
                                        rules={[
                                          { required: true, message: "! Please enter your first name" },
                                          { pattern: /^[a-zA-Z\s'-]+$/, message: "! First name can only contain letters, spaces, hyphens, and apostrophes" },
                                        ]}
                                      >
                                        <Input
                                          placeholder="Enter First Name"
                                          maxLength="20"
                                          onKeyDown={(e) => {
                                            const regex = /^[a-zA-Z\s'-]$/;
                                            if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={handleNameChange}
                                        />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="Last Name"
                                        name="lastName"
                                        rules={[
                                          { required: true, message: "! Please enter your last name" },
                                          { pattern: /^[a-zA-Z\s'-]+$/, message: "! Last name can only contain letters, spaces, hyphens, and apostrophes" },
                                        ]}
                                      >
                                        <Input
                                          placeholder="Enter Last Name"
                                          maxLength="20"
                                          onKeyDown={(e) => {
                                            const regex = /^[a-zA-Z\s'-]$/;
                                            if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={handleNameChange}
                                        />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <Form.Item label="Preferred Name (If different from legal name)" name="PreferredName">
                                        <Input placeholder="Enter Preferred Name" maxLength="20" />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-lg-12 col-sm-12">
                                      <Form.Item
                                        label="Username"
                                        name="userName"
                                        rules={[{ required: true, message: "! Please enter your username." }]}
                                      >
                                        <Input
                                          placeholder="Enter User Name"
                                          maxLength="20"
                                          onChange={handleUsernameChange}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-3 col-sm-3">
                                      <FormItem
                                        label="Sex"
                                        name="gender"
                                        rules={[{ required: true, message: "! Please enter your Sex" }]}
                                      >
                                        <Select options={sexOptions} />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-9 col-sm-9">
                                      <FormItem
                                        label="Pronouns"
                                        name="Pronouns"
                                        rules={[{ required: true, message: "! Please enter your preferred pronouns" }]}
                                      >
                                        <Select
                                          options={pronouns}
                                          value={selectedPronoun?.value}
                                          onChange={(value) => {
                                            const matching = pronouns.find((p) => p.value === value);
                                            setSelectedPronoun(matching);
                                            form.setFieldsValue({ Pronouns: value });
                                          }}
                                        />
                                      </FormItem>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        label="Password"
                                        name="password"
                                        rules={[{ required: true, message: "! Please enter your password." }]}
                                      >
                                        <Input.Password
                                          placeholder="Enter Password"
                                          style={{ borderColor: "#000" }}
                                          onChange={(e) => setPassword(e.target.value)}
                                          onBlur={() => setPasswordFocused(false)}
                                          onFocus={() => setPasswordFocused(true)}
                                        />
                                      </FormItem>
                                    </div>
                                  </div>

                                  {passwordFocused && (
                                    <Card>
                                      <div>Password must contain:</div>
                                      <div style={{ color: passwordValidations.minLength ? "green" : "red" }}>
                                        {passwordValidations.minLength ? "✓" : "✗"} 8 characters minimum
                                      </div>
                                      <div style={{ color: passwordValidations.lowercase ? "green" : "red" }}>
                                        {passwordValidations.lowercase ? "✓" : "✗"} One lowercase character
                                      </div>
                                      <div style={{ color: passwordValidations.uppercase ? "green" : "red" }}>
                                        {passwordValidations.uppercase ? "✓" : "✗"} One uppercase character
                                      </div>
                                      <div style={{ color: passwordValidations.number ? "green" : "red" }}>
                                        {passwordValidations.number ? "✓" : "✗"} One number
                                      </div>
                                      <div style={{ color: passwordValidations.specialChar ? "green" : "red" }}>
                                        {passwordValidations.specialChar ? "✓" : "✗"} One special character
                                      </div>
                                      <div style={{ color: passwordValidations.notUsername ? "green" : "red" }}>
                                        {passwordValidations.notUsername ? "✓" : "✗"} Not the same as the username
                                      </div>
                                    </Card>
                                  )}

                                  <div className="row mb-2">
                                    <div className="col-lg-12 col-sm-12">
                                      <Form.Item
                                        label="Confirm Password"
                                        name="confirmPassword"
                                        rules={[
                                          { required: true, message: "" },
                                          {
                                            validator: (_, value) =>
                                              value === password ? Promise.resolve() : Promise.reject("Passwords do not match"),
                                          },
                                        ]}
                                      >
                                        <Input.Password />
                                      </Form.Item>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                      <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[
                                          { required: true, message: "Please input your email!" },
                                          { type: "email", message: "! Please enter a valid email" },
                                        ]}
                                      >
                                        <Input
                                          maxLength="60"
                                          placeholder="Enter Email"
                                          onBlur={handleEmailLookup}
                                        />
                                      </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="Uli Number"
                                        name="uli"
                                        rules={[{ required: true, message: "! Please enter your ULI Number" }]}
                                        extra="This is your permanent ID within the health system which can be found on your health care card."
                                      >
                                        <Input placeholder="000000" maxLength="20" />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        label="Address"
                                        name="address"
                                        rules={[{ required: true, message: "! Please enter your Address" }]}
                                      >
                                        <Input placeholder="Enter Address" />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem label="Apartment, Suite, etc" name="appartmentOrSuite">
                                        <Input placeholder="Enter Apartment Or Suite" />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="Country"
                                        name="country"
                                        rules={[{ required: true, message: "! Please enter your country" }]}
                                      >
                                        <Select
                                          options={countries}
                                          value={selectedCountry?.value}
                                          onChange={(value) => {
                                            const matching = countries.find((c) => c.value === value);
                                            setSelectedCountry(matching);
                                            form.setFieldsValue({ country: value });
                                            setSelectedState(null);
                                            form.setFieldsValue({ stateProvince: null });
                                          }}
                                        />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="State/Province"
                                        name="stateProvince"
                                        rules={[{ required: true, message: "! Please enter your state" }]}
                                      >
                                        <Select
                                          options={states[selectedCountry?.value]}
                                          value={selectedState?.value}
                                          onChange={(value) => {
                                            const matching = states[selectedCountry?.value]?.find((s) => s.value === value);
                                            setSelectedState(matching);
                                            form.setFieldsValue({ stateProvince: value });
                                          }}
                                          disabled={!selectedCountry}
                                        />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <Form.Item
                                        label="City"
                                        name="city"
                                        rules={[{ required: true, message: "! Please enter your city" }]}
                                      >
                                        <Input placeholder="Enter City" />
                                      </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="Postal Code"
                                        name="postalCode"
                                        rules={[{ required: true, message: "! Please enter your Postal Code" }]}
                                      >
                                        <Input maxLength={6} placeholder="Enter Postal Code" />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        label="Phone Number"
                                        name="phoneNumber"
                                        rules={[{ required: true, message: "! Please enter your Phone number" }]}
                                      >
                                        <ReactInputMask mask="+1 (999) 999-9999" maskChar={null}>
                                          {(inputProps) => (
                                            <Input {...inputProps} placeholder="Enter Phone Number" />
                                          )}
                                        </ReactInputMask>
                                      </FormItem>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <Form.Item
                                        label="Date of Birth"
                                        name="dob"
                                        rules={[{ required: true, message: "! Please enter date of birth" }]}
                                      >
                                        <DatePicker
                                          disabledDate={disableBefore2006}
                                          defaultPickerValue={dayjs(`${startYear}-01-01`)}
                                          style={{ width: "100%", height: "42px", borderColor: "#000" }}
                                          onChange={handleDateChange}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-4 col-sm-4">
                                      <div
                                        style={{
                                          background: "#C2E6F8",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: 10,
                                          color: "#000",
                                          marginBottom: 30,
                                          borderRadius: 10,
                                          fontSize: "15px",
                                        }}
                                      >
                                        <Radio.Group
                                          value={unit}
                                          onChange={(e) => handleSetUnit(e.target.value)}
                                          style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}
                                        >
                                          <Radio value="Metric" style={{ margin: "0 10px" }}>Metric</Radio>
                                          <Radio value="Imperial" style={{ margin: "0 10px" }}>Imperial</Radio>
                                        </Radio.Group>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-sm-4">
                                      <Form.Item
                                        name="Height"
                                        label=""
                                        rules={[
                                          { required: true, message: "Please enter your height" },
                                          {
                                            validator: (_, value) => {
                                              const isValid =
                                                unit === "Metric"
                                                  ? value >= 50 && value <= 250
                                                  : feet >= 1 && feet <= 8 && inches >= 0 && inches <= 11;
                                              return isValid
                                                ? Promise.resolve()
                                                : Promise.reject(
                                                    `Height must be valid for ${unit}, ${unit === "Metric" ? "between 50 cm and 250 cm" : "between 1 ft and 8 ft, with inches between 0 and 11"}`
                                                  );
                                            },
                                          },
                                        ]}
                                      >
                                        {unit === "Metric" ? (
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <Input
                                              type="number"
                                              className="input_questionnaire"
                                              placeholder="Enter Height"
                                              value={heightOfPatient}
                                              min={0}
                                              onChange={(e) => {
                                                setHeightOfPatient(e.target.value);
                                                form.setFieldsValue({ Height: e.target.value });
                                              }}
                                              style={{ marginRight: "10px" }}
                                            />
                                            <span>cm</span>
                                          </div>
                                        ) : (
                                          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                            <Input
                                              type="number"
                                              className="input_questionnaire"
                                              placeholder="ft."
                                              value={feet}
                                              onChange={(e) => {
                                                setFeet(e.target.value);
                                                form.setFieldsValue({ Height: `${e.target.value}-${inches}` });
                                              }}
                                              min={0}
                                            />
                                            <span>ft</span>
                                            <Input
                                              type="number"
                                              className="input_questionnaire"
                                              placeholder="in."
                                              value={inches}
                                              min={0}
                                              onChange={(e) => {
                                                setInches(e.target.value);
                                                form.setFieldsValue({ Height: `${feet}-${e.target.value}` });
                                              }}
                                            />
                                            <span>in</span>
                                          </div>
                                        )}
                                      </Form.Item>
                                    </div>
                                    <div className="col-lg-4 col-sm-4">
                                      <Form.Item
                                        label=""
                                        name="Weight"
                                        rules={[
                                          { required: true, message: "Please enter your weight" },
                                          {
                                            validator: (_, value) => {
                                              const isValid = value >= 10 && value <= 500;
                                              return isValid ? Promise.resolve() : Promise.reject(`Weight must be valid for ${unit}`);
                                            },
                                          },
                                        ]}
                                      >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <Input
                                            type="number"
                                            className="input_questionnaire"
                                            placeholder="Enter Weight"
                                            value={weightOfPatient}
                                            onChange={(e) => {
                                              setWeightOfPatient(e.target.value);
                                              form.setFieldsValue({ Weight: e.target.value });
                                            }}
                                            style={{ marginRight: "10px" }}
                                            min={0}
                                          />
                                          <span>{unit === "Metric" ? "kg" : "lbs"}</span>
                                        </div>
                                      </Form.Item>
                                    </div>
                                  </div>
                                </>
                              )}
                              {currentStep === 1 && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="First Name"
                                        name="PartnerFirstName"
                                        rules={[{ pattern: /^[a-zA-Z\s'-]*$/, message: "! First name can only contain letters, spaces, hyphens, and apostrophes" }]}
                                      >
                                        <Input
                                          placeholder="Enter First Name"
                                          onKeyDown={(e) => {
                                            const regex = /^[a-zA-Z\s'-]$/;
                                            if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={handleNameChange}
                                        />
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                      <FormItem
                                        label="Last Name"
                                        name="PartnerLastName"
                                        rules={[{ pattern: /^[a-zA-Z\s'-]*$/, message: "! Last name can only contain letters, spaces, hyphens, and apostrophes" }]}
                                      >
                                        <Input
                                          placeholder="Enter Last Name"
                                          onKeyDown={(e) => {
                                            const regex = /^[a-zA-Z\s'-]$/;
                                            if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                              e.preventDefault();
                                            }
                                          }}
                                          onChange={handleNameChange}
                                        />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem label="Sex" name="PartnerSex">
                                        <Select options={sexOptions} />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row ">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem label="Pronouns" name="PartnerPronouns">
                                        <Select
                                          options={pronouns}
                                          value={selectedPartnerPronoun?.value}
                                          onChange={(value) => {
                                            const matching = pronouns.find((p) => p.value === value);
                                            setSelectedPartnerPronoun(matching);
                                            form.setFieldsValue({ PartnerPronouns: value });
                                          }}
                                        />
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <Form.Item label="Date of Birth" name="PartnerDob">
                                        <DatePicker
                                          defaultPickerValue={dayjs(`${startYear}-01-01`)}
                                          format="YYYY-MM-DD"
                                          style={{ width: "100%", height: "42px", borderColor: "#000" }}
                                          onChange={handlePartnerDateChange}
                                          disabledDate={disableUnder18Years}
                                        />
                                      </Form.Item>
                                    </div>
                                  </div>
                                </>
                              )}
                              {currentStep === 2 && (
                                <>
                                  <p style={{ color: "#335CAD", fontWeight: "bold" }}>
                                    {" "}
                                    Authorization for Email Communication
                                  </p>
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        name="isSMS"
                                        valuePropName="checked"
                                        rules={[{ required: true, message: "! Please confirm" }]}
                                      >
                                        <Checkbox>
                                          I authorize My Fertility Labs to send text messages to the phone number I provided
                                        </Checkbox>
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        name="isSendResultToEmail"
                                        valuePropName="checked"
                                        rules={[{ required: true, message: "! Please confirm" }]}
                                      >
                                        <Checkbox>
                                          I authorize My Fertility Labs Inc. to send my test results to the email
                                          address I have provided. I acknowledge that email is not a secure
                                          communication method. I verify that the provided email address is correct
                                          and accurately recorded. If the email address is not mine, I permit the
                                          owner of the provided email address to receive my test results on my behalf
                                        </Checkbox>
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        name="IAgreeToReceiveInformation"
                                        valuePropName="checked"
                                        rules={[{ required: true, message: "! Please confirm" }]}
                                      >
                                        <Checkbox>
                                          I agree to receive both online and in-person care and authorizes the
                                          sharing of this information with healthcare personnel, including
                                          clinician, fertility coach, or other healthcare support, solely for the
                                          purpose of providing care to the individual or couple
                                        </Checkbox>
                                      </FormItem>
                                    </div>
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        name="isAcceptTermsAndCondition"
                                        valuePropName="checked"
                                        rules={[{ required: true, message: "! You must agree to the terms and conditions to proceed." }]}
                                      >
                                        <Checkbox>
                                          I have read and accept the terms of the{" "}
                                          <span
                                            className="text-primary"
                                            onClick={() => window.open("/collection-notice", "_blank")}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Collection Notice
                                          </span>
                                          ,{" "}
                                          <span
                                            className="text-primary"
                                            onClick={() => window.open("/terms-of-service", "_blank")}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Terms of Services
                                          </span>
                                          , and{" "}
                                          <span
                                            className="text-primary"
                                            onClick={() => window.open("/privacy-policy", "_blank")}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Privacy Policy
                                          </span>
                                        </Checkbox>
                                      </FormItem>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <p style={{ color: "#335CAD", fontWeight: "bold" }}>
                                      Digital Signature:
                                    </p>
                                    <div className="col-lg-12 col-sm-12">
                                      <FormItem
                                        name="DigitalSignature"
                                        valuePropName="checked"
                                        rules={[{ required: true, message: "! Please confirm" }]}
                                      >
                                        <Checkbox>
                                          By signing below, I acknowledge that I have read and understand the consent
                                          provided above
                                        </Checkbox>
                                      </FormItem>
                                    </div>

                                    <Form.Item
                                      name="DigitalSignatureName"
                                      rules={[{ required: true, message: "! Please confirm" }]}
                                    >
                                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <p style={{ fontWeight: "bold", color: "#000", margin: 0, whiteSpace: "nowrap" }}>
                                          Type Your Name as a Signature:
                                        </p>
                                        <Input
                                          style={{
                                            border: "none",
                                            borderBottom: "1px solid #000",
                                            boxShadow: "none",
                                            borderRadius: 0,
                                            width: "50%",
                                            padding: "4px 0",
                                          }}
                                          placeholder=""
                                        />
                                      </div>
                                    </Form.Item>
                                  </div>
                                  <div className="text-center" style={{ display: "none" }}>
                                    <a className="small" href="/">
                                      Already have an account? Sign In
                                    </a>
                                  </div>
                                </>
                              )}
                              <div className="steps-action">
                                {currentStep < 2 && (
                                  <Button
                                    type="primary"
                                    disabled={currentStep === 0 && !step0Valid}
                                    style={{
                                      width: isMobile ? "" : "200px",
                                      height: "46.42px",
                                      borderRadius: 10,
                                      backgroundColor: currentStep === 0 && !step0Valid ? "#ccc" : "rgb(1, 173, 240)",
                                      float: "right",
                                    }}
                                    onClick={() => nextStep()}
                                  >
                                    Continue
                                  </Button>
                                )}
                                {currentStep === 2 && (
                                  <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={buttonDisabled}
                                    style={{
                                      width: isMobile ? "" : "200px",
                                      height: "46.42px",
                                      backgroundColor: "rgb(1, 173, 240)",
                                      float: "right",
                                    }}
                                  >
                                    {showSpinner && <Spin size="small" />} Done
                                  </Button>
                                )}
                                {currentStep >= 1 && (
                                  <Button
                                    style={{ width: isMobile ? "" : "200px", height: "46.42px" }}
                                    onClick={() => prevStep()}
                                  >
                                    Previous
                                  </Button>
                                )}
                              </div>
                            </Form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              span={2}
              className="column-3"
              style={{ backgroundColor: "#EFD0BD" }}
            ></Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default CompleteSignup;
